import React from "react";
import { Button, ButtonProps, Loader } from "@mantine/core";
import "./EButton.scss";

interface IProps {
  color?: string;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "clear" | "outline" | "destructive" | "btn-light" | "ghost";
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  onClick: () => void;
  rightIcon?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

// Configuration object for button variants and sizes
const buttonConfig = {
  variant: {
    primary: "btn--primary",
    secondary: "btn--secondary",
    clear: "btn--clear",
    outline: "btn--outline",
    destructive: "btn--destructive",
    "btn-light": "btn--btn-light",
    ghost: "btn--ghost",
  },
  size: {
    xs: "btn--xs",
    sm: "btn--sm",
    md: "btn--md",
    lg: "btn--lg",
    xl: "btn--xl",
    "2xl": "btn--2xl",
  },
  state: {
    disabled: "--disabled",
  },
};

export function EButton(props: IProps) {
  const {
    variant = "primary",
    size = "lg",
    disabled = false,
    loading = false,
    className = "",
    onClick,
    children,
  } = props;

  // Build className using the configuration object
  const variantClass = buttonConfig.variant[variant];
  const sizeClass = buttonConfig.size[size];
  const disabledSuffix = disabled ? buttonConfig.state.disabled : "";

  const buttonClassName = `btn ${variantClass}${disabledSuffix} ${sizeClass} ${className}`.trim();

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <div className={buttonClassName} onClick={handleClick}>
      {loading ? (
        <Loader className="btn--loader" color="white" size="xs" />
      ) : (
        <>{children}</>
      )}
    </div>
  );
}
